"use client";

import { c as _c } from "react/compiler-runtime";
import { Check } from "lucide-react";
import { Collection as AriaCollection, Header as AriaHeader, ListBox as AriaListBox, ListBoxItem as AriaListBoxItem, ListBoxItemProps as AriaListBoxItemProps, ListBoxProps as AriaListBoxProps, Section as AriaSection, composeRenderProps } from "react-aria-components";
import { cn } from "@/utils/cn";
const ListBoxSection = AriaSection;
const ListBoxCollection = AriaCollection;
function ListBox(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = composeRenderProps(className, _temp);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <AriaListBox className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp(className_0) {
  return cn(className_0, "group overflow-auto rounded-md border bg-popover p-1 text-popover-foreground shadow-md outline-none", "data-[empty]:p-6 data-[empty]:text-center data-[empty]:text-sm");
}
const ListBoxItem = t0 => {
  const $ = _c(13);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  const t1 = props.textValue || (typeof children === "string" ? children : undefined);
  let t2;
  if ($[4] !== className) {
    t2 = composeRenderProps(className, _temp2);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== children) {
    t3 = composeRenderProps(children, _temp3);
    $[6] = children;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== props || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <AriaListBoxItem textValue={t1} className={t2} {...props}>{t3}</AriaListBoxItem>;
    $[8] = props;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
function ListBoxHeader(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("py-1.5 pl-8 pr-2 text-sm font-semibold", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <AriaHeader className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export { ListBox as _ListBox, ListBoxCollection, ListBoxHeader, ListBoxItem, ListBoxSection };
function _temp2(className_0) {
  return cn("relative flex w-full cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none", "data-[disabled]:pointer-events-none data-[disabled]:opacity-50", "data-[focused]:bg-accent data-[focused]:text-accent-foreground", "data-[hovered]:bg-accent data-[hovered]:text-accent-foreground", "data-[selection-mode]:pl-8", className_0);
}
function _temp3(children_0, renderProps) {
  return <>{renderProps.isSelected && <span className="absolute left-2 flex size-4 items-center justify-center"><Check className="size-4" /></span>}{children_0}</>;
}